import genericFields from './generic-fields'

const createQuery = (subQuery, additionalQuery = '') => {
  const query = `query Resource($url:String!${additionalQuery}) {
    ${genericFields()}
    resource(url:$url) {
      __typename
      ...on Redirect {
        redirectUrl
      }
      ${subQuery}
    }
  }`
  return query
}
export default createQuery
